import { alpha, createTheme } from "@mui/material/styles";

export const COLORS = {
  BlackText: "#151414ff",
  blackColor: "#280101ff",
  WhiteText: "#FFFFFF",
  WhiteBackground: "#FFFFFF",
  activeBackground: "#D9D9D914",
  MainColor: "#1976d2",
  SUCCESS: "#20ce60ff",
  ORANGE: "#f59e0b",
  BorderColor: "#e0e0e0",
  textFieldBackgroundColor: "#E0E0E0",
  placeHolderColor: "#868585",
  RED: "#eb0000ff",
  typographyColor: "#1C1C1C",
  SidebarActiveBg: "#e0f2ff",
  SidebarActiveText: "#2563eb",
  SidebarInactiveText: "#6b7280",
  MainBackground: "#f7f7f7",
};

// Palette, typography and shape stay on MUI's defaults so existing pages render
// exactly as before; this only layers motion and interaction polish on top.
const baseTheme = createTheme();
const easeOut = "cubic-bezier(0.2, 0, 0, 1)";

export const appTheme = createTheme(baseTheme, {
  components: {
    MuiTabs: {
      styleOverrides: {
        indicator: {
          height: 3,
          borderRadius: "3px 3px 0 0",
          transition: `all 300ms ${easeOut}`,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          minHeight: 44,
          borderRadius: "8px 8px 0 0",
          transition: baseTheme.transitions.create(
            ["color", "background-color"],
            { duration: baseTheme.transitions.duration.short }
          ),
          "&:hover": {
            color: baseTheme.palette.primary.main,
            backgroundColor: alpha(baseTheme.palette.primary.main, 0.04),
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          transition: baseTheme.transitions.create(
            ["background-color", "box-shadow", "border-color", "color", "transform"],
            { duration: baseTheme.transitions.duration.short }
          ),
          "&:active": { transform: "scale(0.97)" },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          transition: baseTheme.transitions.create(
            ["background-color", "color", "transform"],
            { duration: baseTheme.transitions.duration.shortest }
          ),
          "&:active": { transform: "scale(0.92)" },
        },
      },
    },
  },
});
